import { areaSelectControl } from '../../../../../constants/form-control/client/area/area-select';
import { FormControlUtil } from '../../../../../core/utils/form-control';

export const SCAN_AREA_FORM_CONTROLS = {
  area_id: FormControlUtil.mergeFormControl(areaSelectControl, { key: 'area_id' }),
};
